var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Translate } from "../../../../../../../../../I18N";
import React from 'react';

const NoQualifiedTemplatesMessage = () => /*#__PURE__*/
_jsx("div", { className: "flex flex-col gap-10 items-center  font-semibold lead text-xs uppercase" }, void 0, /*#__PURE__*/
_jsx("p", {}, void 0, /*#__PURE__*/
_jsx(Translate, { className: "text-gray-900" }, void 0, "No valid target template available")
), /*#__PURE__*/
_jsx("p", { className: "flex flex-col gap-5 text-gray-500 items-center" }, void 0, /*#__PURE__*/
_jsx("div", { id: "label-template-requirements" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "A target template needs at least"), ":"
), /*#__PURE__*/
_jsx("ul", {
  className: "list-disc list-inside flex flex-col gap-1",
  "aria-labelledby": "label-template-requirements" }, void 0, /*#__PURE__*/

_jsx("li", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "1 Rich text property")
), /*#__PURE__*/
_jsx("li", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "1 Numeric Property")
)
)
)
);


export { NoQualifiedTemplatesMessage };